import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import SimpleParallax from "simple-parallax-js";
import Swiper from "swiper";

var images = document.querySelectorAll("section.cta img");

Array.from(document.querySelectorAll("section.cta .swiper")).map((hero) => {
	const swiper = new Swiper(hero, {
		modules: [Autoplay, Pagination, EffectFade],
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 7500,
		},
		loop: true,
	});
});
